import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import axios from 'axios';
import { updateAnswer } from '~/api';
import { addAnswerEntity } from '~/redux/actions/workspaceActions';
import Icon from '~/components/common/icon';

/**
 * New matrix answer
 */
class NewMatrixAnswerEntity extends Component {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );

		this.state = {
			showForm: false,
			answer: '',
			sortString: '',
		};

		// cancel token to abort any requests when unmounting the component.
		this.signal = axios.CancelToken.source();

		this.handleShowForm = this.handleShowForm.bind( this );
		this.handleChange = this.handleChange.bind( this );
		this.handleSubmit = this.handleSubmit.bind( this );

		// to prevent memory leaks
		this._isMounted = false;
	}

	/**
	 * When component is mounted
	 */
	componentDidMount() {
		this._isMounted = true;
	}

	/**
	 * Cancel all requests when unmounting the component.
	 */
	componentWillUnmount() {
		this.signal.cancel();
		this._isMounted = false;
	}

	/**
	 * Handles the form submission. Should be replaced by calls to the API
	 *
	 * @param {handleSubmit} e
	 */
	async handleSubmit( e ) {
		e.preventDefault();

		const { answer, sortString } = this.state;
		const { type, parentLesson, addAnswerEntity, question } = this.props;

		if ( 'answer' === type ) {
			// Setup a new answer object
			const newAnswer = {
				answer,
				html: false,
				points: 0,
				correct: false,
				sortString,
				sortStringHtml: false,
				graded: '1',
				gradingProgression: '',
				gradedType: 'text',
				type: 'answer',
				answerType: question.question_type,
			};

			// Create new answers array for our question type
			const newAnswers = [
				...question.answers[
					LearnDashData.questions_types_map[ question.question_type ]
				],
				newAnswer,
			];

			// Update question
			const res = await updateAnswer( parentLesson, newAnswers );

			if ( 200 === res ) {
				// Update our workspace
				addAnswerEntity( newAnswer, question );
			}
		}
	}

	/**
	 * Shows the form to add the new answer.
	 *
	 * @param {handleShowForm} e
	 */
	handleShowForm( e ) {
		e.preventDefault();

		this.setState( ( { showForm } ) => ( { showForm: ! showForm } ) );
	}

	/**
	 * Change to input fields.
	 *
	 * @param {handleChange} e
	 */
	handleChange( e ) {
		const { target } = e;
		const { name, value } = target;

		this.setState( {
			[ name ]: value,
		} );
	}

	/**
	 * Render function
	 *
	 * @event handleSubmit
	 * @event handleShowForm
	 * @event handleChange
	 */
	render() {
		const { showForm, answer, sortString } = this.state;
		const { type } = this.props;
		return (
			<div
				className={ `ld__builder--new-entity -matrix ${
					showForm ? '-expanded' : '-collapsed'
				}` }
			>
				{ ! showForm && (
					<a href="#" onClick={ this.handleShowForm }>
						<Icon icon="plus" />

						{ `${ LearnDashData.i18n.new_element_labels[ type ] }` }
					</a>
				) }

				{ showForm && (
					<div>
						<form onSubmit={ this.handleSubmit }>
							<input
								type="text"
								name="answer"
								autoFocus
								value={ answer }
								placeholder={ `${ LearnDashData.i18n.criterion }` }
								onChange={ this.handleChange }
							/>
							<input
								type="text"
								name="sortString"
								value={ sortString }
								placeholder={ `${ LearnDashData.i18n.sort_element }` }
								onChange={ this.handleChange }
							/>
							<span>
								<input
									type="submit"
									value={ `${ LearnDashData.i18n.add_element_labels[ type ] }` }
									className="is-primary ld__builder--new-entity-button"
								/>
								<input
									type="button"
									onClick={ this.handleShowForm }
									value={ `${ LearnDashData.i18n.cancel }` }
									className="is-default ld__builder--new-entity-button"
								/>
							</span>
						</form>
					</div>
				) }
			</div>
		);
	}
}

/**
 * Valid props
 */
NewMatrixAnswerEntity.propTypes = {
	type: PropTypes.string,
	addAnswerEntity: PropTypes.func,
	parentLesson: PropTypes.number,
	question: PropTypes.object,
	data: PropTypes.shape( {
		labels: PropTypes.object,
	} ),
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = ( state ) => ( {
	...state,
} );

/**
 *
 * @param {*} dispatch
 */
const mapDispatchToProps = ( dispatch ) => ( {
	addAnswerEntity: ( answer, parent ) =>
		dispatch( addAnswerEntity( answer, parent ) ),
} );

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( NewMatrixAnswerEntity );
